import { Message } from '@patsnap/tahiti-core/common/message';
import { isPsHttpError } from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ErrorHandlerContribution, ErrorHandlerRegistry } from '@patsnap/tahiti-core/common/error-handler-contribution';
import { I18nService } from '@/services/i18n-service';
import { HttpSuccessException } from '@eureka/services/src/exception';
import _ from 'lodash';

@injectable()
export class AiDisclosureErrorHandler implements ErrorHandlerContribution {
    constructor(
        @inject(Message)
        private readonly _message: Message,
        @inject(I18nService)
        private readonly _i18nService: I18nService
    ) { }

    private _showErrorMessageByCode(code: number, params?: Record<string, string>) {
        const errorCodeI18nKey = `commonStatusCode.${code || '400'}`;
        const defaultErrorCodeI18nKey = 'commonStatusCode.400';
        const message = this._i18nService.te(errorCodeI18nKey) ? this._i18nService.t(errorCodeI18nKey, params || {}) : this._i18nService.t(defaultErrorCodeI18nKey);
        if (message) {
            this._message.error({
                message,
            });
            return true;
        }
        return false;
    }

    registerHandler(handlers: ErrorHandlerRegistry): void {
        handlers.register((error: Error) => {
            console.error('[Catch]: ', error);
            if (!HttpSuccessException.is(error)) {
                return false;
            }
            const data = error.data;
            return this._showErrorMessageByCode(data.error_code, data.error_params);
        });

        handlers.register((error: Error) => {
            console.error('[Catch]: ', error);
            if (!isPsHttpError(error)) {
                return false;
            }
            const data = error.cause;
            return this._showErrorMessageByCode(data.error_code);
        });
    }
}
